import React from 'react';
import { Menubar } from 'primereact/menubar';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/auth';
import { Button } from 'primereact/button';

export default function Menu(props) {
    const navigate = useNavigate();
    const auth = useAuth();

    const dashboard = [
        {
            label: 'Home',
            icon: 'pi pi-home',
            command: () => navigate('/')
        },
        {
            label: 'Dashboard Defeitos',
            icon: 'pi pi-chart-bar',
            command: () => navigate('/revisao')
        },
        ...(auth.user.email === 'endiara@souzacambos.com.br' ? [
            {
                label: 'Defeitos',
                icon: 'pi pi-exclamation-circle',
                items: [
                    {
                        label: 'Relatório Diário de Defeitos',
                        command: () => navigate('/defeitos/relatorio-diario')
                    },
                    {
                        label: 'Relatório Acumulado de Defeitos por Setor',
                        command: () => navigate('/defeitos/relatorio-metragem')
                    },
                ]
            },
        ] : [])
    ];

    const producao = [
        {
            label: 'Home',
            icon: 'pi pi-home',
            command: () => navigate('/')
        },
        {
            label: 'Produção Geral',
            icon: 'pi pi-date',
            command: () => navigate('/producao-geral')
        },
        {
            label: 'Relatório de Defeitos',
            icon: 'pi pi-chart-bar',
            command: () => navigate('/defeitos/relatorio')
        },
        {
            label: 'Eficiência Teares',
            icon: 'pi pi-percentage',
            command: () => navigate('/eficiencia-teares')
        },
        {
            label: 'Cortes',
            icon: 'pi pi-info',
            command: () => navigate('/cortes')
        },
        {
            label: 'Ocorrências',
            icon: 'pi pi-info',
            command: () => navigate('/ocorrencias')
        }
    ];

    const revisao = [
        {
            label: 'Home',
            icon: 'pi pi-home',
            command: () => navigate('/')
        },
        {
            label: 'Defeitos',
            icon: 'pi pi-list',
            command: () => navigate('/cadastros/defeitos')
        },
        {
            label: 'Histórico',
            icon: 'pi pi-clock',
            command: () => navigate('/defeitos/historico')
        },
        {
            label: 'Relatório',
            icon: 'pi pi-chart-bar',
            command: () => navigate('/defeitos/relatorio')
        },
        {
            label: 'Dashboard Defeitos',
            icon: 'pi pi-chart-bar',
            command: () => navigate('/revisao')
        },
        {
            label: 'Balanceamento de Produção',
            command: () => navigate('/balanceamento-producao')
        },
    ];

    const items = [
        {
            label: 'Home',
            icon: 'pi pi-chart-bar',
            command: () => navigate('/')
        },
        {
            label: 'Importações',
            icon: 'pi pi-bookmark',
            command: () => navigate('/importacoes')
        },
        {
            label: 'Cadastros',
            icon: 'pi pi-list',
            items: [
                {
                    label: 'Artigos PCP',
                    command: () => navigate('/cadastros/artigos-pcp')
                },
                {
                    label: 'Colaboradores',
                    command: () => navigate('/cadastros/colaboradores')
                },
                {
                    label: 'Defeitos',
                    command: () => navigate('/cadastros/defeitos')
                },
                {
                    label: 'Estoque',
                    items: [
                        {
                            label: 'Fio',
                            command: () => navigate('/estoque/fio')
                        },
                        {
                            label: 'Fio Mapeamento',
                            command: () => navigate('/cadastros/fio-mapeamento')
                        }
                    ]
                },
                {
                    label: 'Metragem por Período',
                    command: () => navigate('/cadastros/metragem-periodo')
                },
                {
                    label: 'Media por Artigo',
                    command: () => navigate('/cadastros/artigo-tempo')
                },
                {
                    label: 'Metas Têxtil',
                    command: () => navigate('/cadastros/metas-textil')
                },
                {
                    label: 'Paradas',
                    command: () => navigate('/cadastros/paradas')
                },
                {
                    label: 'Prêmio Eficiência',
                    command: () => navigate('/cadastros/premio-eficiencia')
                },
                {
                    label: 'Qualidade',
                    command: () => navigate('/cadastros/qualidade')
                },
                {
                    label: 'Resíduos',
                    command: () => navigate('/cadastros/residuos')
                },
                {
                    label: 'Tipos de Parada',
                    command: () => navigate('/cadastros/tipos-parada')
                },
                {
                    label: 'Turmas',
                    command: () => navigate('/cadastros/turmas')
                },
            ]
        },
        {
            label: 'Defeitos',
            icon: 'pi pi-exclamation-circle',
            items: [
                {
                    label: 'Histórico',
                    command: () => navigate('/defeitos/historico')
                },
                {
                    label: 'Histórico - Gráficos',
                    command: () => navigate('/defeitos/historico-graficos')
                },
                {
                    label: 'Relatório',
                    command: () => navigate('/defeitos/relatorio')
                },
                {
                    label: 'Relatório Diário de Defeitos',
                    command: () => navigate('/defeitos/relatorio-diario')
                },
                {
                    label: 'Relatório Diário de Qualidade',
                    command: () => navigate('/defeitos/relatorio-diario-qualidade')
                },
                {
                    label: 'Relatório Acumulado de Defeitos por Setor',
                    command: () => navigate('/defeitos/relatorio-metragem')
                },
                {
                    label: 'Prêmio',
                    command: () => navigate('/defeitos/premio')
                },
                {
                    label: 'Dashboard Defeitos',
                    command: () => navigate('/revisao')
                }
            ]
        },
        {
            label: 'Paradas',
            icon: 'pi pi-history',
            items: [
                {
                    label: 'Lançamento',
                    command: () => navigate('/paradas/lancamento')
                },
                {
                    label: 'Histórico',
                    command: () => navigate('/paradas/historico')
                }
            ]
        },
        {
            label: 'Manutenção',
            items: [
                {
                    label: 'Máquinas',
                    command: () => navigate('/maquinas')
                },
                {
                    label: 'Estoque de Produtos',
                    command: () => navigate('/estoque/produtos')
                },
                {
                    label: 'Produtos',
                    command: () => navigate('/produtos')
                },
                {
                    label: 'Programação',
                },
                {
                    label: 'Relatórios',
                    command: () => navigate('/manutencao/relatorios')
                },
                {
                    label: 'Tipos',
                    command: () => navigate('/manutencao/tipos')
                }
            ]
        },
        {
            label: 'Ocorrências',
            icon: 'pi pi-info',
            command: () => navigate('/ocorrencias')
        },
        {
            label: 'Relatórios',
            icon: 'pi pi-chart-bar',
            command: () => navigate('/relatorios')
        },
        {
            label: 'PCP',
            items: [
                {
                    label: "Índice Venda Corte",
                    command: () => navigate('/indice-venda-corte')
                }
            ]
        },
        {
            label: 'Programação Rolo',
            icon: 'pi pi-calendar',
            command: () => navigate('/programacao')
        },
        {
            label: 'Utilidades',
            icon: 'pi pi-cog',
            items: [
                {
                    label: 'Balanceamento de Produção',
                    command: () => navigate('/balanceamento-producao')
                },
                {
                    label: 'Configuração',
                    command: () => navigate('/configuracao')
                },
                {
                    label: 'Controle Turma',
                    command: () => navigate('/controle-turma')
                },  
                {
                    label: 'Cortes',
                    command: () => navigate('/cortes')
                },
                {
                    label: 'Dashboard Sanforizadeira',
                    command: () => navigate('/acabamento/dashboard')
                },
                {
                    label: 'Eficiência Teares',
                    command: () => navigate('/eficiencia-teares')
                },
                {
                    label: 'Estoque Fiação',
                    command: () => navigate('/estoque/fiacao')
                },
                {
                    label: 'Layout',
                    command: () => navigate('/layout')
                },
                {
                    label: 'Máquinas',
                    command: () => navigate('/maquinas')
                },
                {
                    label: 'Meta Diária',
                    command: () => navigate('/meta-diaria')
                },
                {
                    label: 'Meta Produção',
                    command: () => navigate('/meta-producao')
                },
                {
                    label: 'Projeção de Produção',
                    command: () => navigate('/relatorio-projecao-producao')
                },
                {
                    label: 'Palete',
                    command: () => navigate('/estoque/paletes')
                },
                {
                    label: 'PCP Restrições',
                    command: () => navigate('/pcp-restricao')
                },
                {
                    label: 'Últimos Paletes',
                    command: () => navigate('/fiacao-tempo-real')
                },
                {
                    label: 'Entradas X Saídas de Tecidos',
                    command: () => navigate('/entradas-saidas')
                },
            ]
        }
    ];

    const acabamento = [
        {
            label: 'Home',
            icon: 'pi pi-home',
            command: () => navigate('/')
        },
        {
            label: 'Cadastros',
            items: [
                {
                    label: 'Paradas',
                    command: () => navigate('/acabamento/cadastro/paradas')
                },
                {
                    label: 'Parâmetros',
                    command: () => navigate('/acabamento/cadastro/parametros')
                },
                {
                    label: 'Temperatura Configuração',
                    command: () => navigate('/acabamento/cadastro/temperatura-configuracao')
                },
            ]
        },
        {
            label: 'Dashboard Defeitos',
            icon: 'pi pi-chart-bar',
            command: () => navigate('/revisao')
        },
        {
            label: 'Programação Rolo',
            icon: 'pi pi-calendar',
            command: () => navigate('/programacao')
        },
        {
            label: 'Dashboard Sanforizadeira',
            command: () => navigate('/acabamento/dashboard')
        },
        {
            label: 'Lançamentos',
            items: [
                {
                    label: 'Gás',
                    items: [
                        {
                            label: 'Lançar',
                            command: () => navigate('/acabamento/gas')
                        },
                        {
                            label: 'Histórico',
                            command: () => navigate('/acabamento/gas-historico')
                        }
                    ]
                },
                {
                    label: 'Paradas',
                    items: [
                        {
                            label: 'Lançar',
                            command: () => navigate('/acabamento/paradas')
                        },
                        {
                            label: 'Histórico',
                            command: () => navigate('/acabamento/paradas-historico')
                        }
                    ]
                },
                {
                    label: 'Temperatura',
                    items: [
                        {
                            label: 'Lançar',
                            command: () => navigate('/acabamento/temperatura/-1')
                        },
                        {
                            label: 'Histórico',
                            command: () => navigate('/acabamento/temperatura-historico')
                        }
                    ]
                }
            ]
        },
        {
            label: 'Balanceamento de Produção',
            command: () => navigate('/balanceamento-producao')
        },
        {
            label: 'Estoque Fiação',
            command: () => navigate('/acabamento/estoque-fiacao')
        },
        {
            label: 'Relatórios',
            command: () => navigate('/acabamento/relatorio')
        }
    ];

    if(auth.user.email === 'sanfo@souzacambos.com.br') {
        acabamento.splice(1, 1);
    }

    const manutencao = [
        {
            label: 'Home',
            icon: 'pi pi-home',
            command: () => navigate('/')
        },
        {
            label: 'Manutenção',
            items: [
                {
                    label: 'Estoque de Produtos',
                    command: () => navigate('/estoque/produtos')
                },
                {
                    label: 'Produtos',
                    command: () => navigate('/produtos')
                },
                {
                    label: 'Programação',
                },
                {
                    label: 'Relatórios',
                    command: () => navigate('/manutencao/relatorios')
                },
                {
                    label: 'Tipos',
                    command: () => navigate('/manutencao/tipos')
                }
            ]
        },
        {
            label: 'Máquinas',
            command: () => navigate('/maquinas')
        },
        {
            label: 'Ocorrências',
            icon: 'pi pi-info',
            command: () => navigate('/ocorrencias')
        }
    ];

    const fiacao = [
        {
            label: 'Home',
            icon: 'pi pi-home',
            command: () => navigate('/')
        },
        {
            label: 'Estoque Fiação',
            command: () => navigate('/estoque/fiacao')
        },
        {
            label: 'Layout',
            command: () => navigate('/layout')
        },
        {
            label: 'Relatórios',
            command: () => navigate('/relatorios')
        },
    ];

    const expedicao = [...dashboard];
    expedicao.push({
        label: 'Balanceamento de Produção',
        command: () => navigate('/balanceamento-producao')        
    })

    const roles = {
        'revisao': revisao,
        'admin': items,
        'producao': producao,
        'acabamento': acabamento,
        'manutencao': manutencao,
        'fiacao': fiacao,
        'dashboard': dashboard,
        'expedicao': expedicao
    }

    const model = roles[auth.user.role] ? roles[auth.user.role] : [];

    return (
        <Menubar 
            popup
            end={<Button 
                className='p-button-danger'
                label='Sair'
                icon='pi pi-power-off'    
                onClick={() => auth.Logout()}
            />}
            model={model}
        />
    )
}